export const DEFAULT_DATE_RANGE = '1_week';

export const DEFAULT_PAGE = '1';

export const DEFAULT_PAGE_SIZE = '10';

export const DEFAULT_SORT_FIELD = 'created_at';

export const INVALID_STATUSES = ['New', 'Future'];

export const PAGE_LIMIT_OPTIONS = [10, 25, 50, 100];

export const SEARCH_CATEGORIES = {
  ORDER: 'order',
  CUSTOMER: 'customer',
  TOTAL: 'total',
};

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
  START_ASC: 'start_asc',
  START_DESC: 'start_desc',
};

export const URL_PARAMS = {
  FILTER_BY: 'filterby',
  DATE_RANGE: 'date_range',
  LIMIT: 'limit',
  OFFSET: 'offset',
  ORDER_BY: 'order_by',
  PAGE: 'page',
  PAGE_SIZE: 'page_size',
  SEARCH: 'q',
  SORT_ORDER: 'sort_order',
  RESTAURANT_ID: 'restaurant_id',
  SERVICE_TYPE: 'service_type',
  CODE: 'code',
  STATE: 'state',
  SCOPE: 'scope',
};

export const CLOSURE_STATUS = {
  SCHEDULED: 'scheduled',
  PAST: 'past',
};
